import { ProfileEditPage } from "@features/security/components/ProfileEditPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck } from "lucide-react";

/**
 * Security — Profile Edit Route
 *
 * Form to edit an existing profile's permissions.
 * Access requires security.profiles.edit permission.
 */
export const Route = createFileRoute("/_app/admin/profiles/$id/edit")({
  loader: requirePermission(PERMISSIONS.SECURITY.PROFILES.EDIT),
  staticData: {
    title: "Modifier profil",
    tab_icon: ShieldCheck,
    permission: PERMISSIONS.SECURITY.PROFILES.EDIT,
    showInNav: false,
    showInBreadcrumb: true,
    description: "Modifier un profil",
  },
  component: ProfileEditPage,
});
